<template>
  <!--骑缝章显示-->
  <div>
    <template v-if="$route.path === '/initiation/toCreate'">
          <!-- <el-button
            v-show="(items > 1) && !showQiFeng && qifengChapList.length"
            type="primary"
            class="close-qifeng"
            size="mini"
            @click="scrollRight">
            <p>设置<br/>骑缝章</p>
          </el-button> -->
          <div
          v-show="showQiFeng"
          class="qifeng-box"
          ref="qifengBox"
          @drop="dropData($event)"
          @dragover="
            ($event) => {
              $event.preventDefault();
            }
          ">
          <div class="qifeng-switch" @click="showQiFeng = !showQiFeng">{{showQiFeng ? '收起' : '展开'}}
            <i :class="showQiFeng ? 'el-icon-d-arrow-right' : 'el-icon-d-arrow-left'"></i>
          </div>
          <!-- 自定义骑缝章容器 -->
          <div class="qifeng-page" v-for="i of 5" :key="'page' + i"></div>
          <p class="vertical-text">骑缝章区域</p>
          <template v-for="(qifeng,i) of qifengChapList">
            <div class="qifeng-sign" style="position:absolute;" :key="i" :id="'qifengSign' + qifeng.cindex">
              <div
                :class="{
                  'qz-new': true,
                  draging: cachetMove && currentIndex === qifeng.cindex,
                  enterprise_qz_new: qifeng.signatoryUserType,
                }"
                :style="{width:`${qifeng.signatoryUserType ? 208 : 115}px`,height:`${qifeng.signatoryUserType ? 230 : 79}px`}"
              >
              <!--
                :style="{width:`${qifeng.signatoryUserType ? 208 : 115}px`,height:`${qifeng.signatoryUserType ? 230 : 79}px`}"
                盖章位置用的实际数据
              -->
                <!-- <a
                  @click="$emit('delQifeng',qifeng.cindex)"
                  href="javascript:void (0)"
                  class="el-icon-error color-danger del-chapter del-chapter__sign"
                ></a> -->
                <div
                  @mousedown.capture="
                    handleCacheMousedown($event, {currentIndex:qifeng.cindex})
                  "
                >
                  <h1>{{ qifeng.signOwner }}</h1>
                  <div
                    :class="[
                      'con',
                      { enterprise_con: qifeng.signatoryUserType, 'padding_top':  qifeng.forge},
                    ]"
                  >
                    <p class="text" v-if="qifeng.name">
                      {{ qifeng.name | eclipse}}
                    </p>
                  </div>
                  <img src="../../assets/images/move-icon.png" />
                  <span class="time">日期：XXXX</span>
                </div>
                </div>
            </div>
          </template>
        </div>
        </template>
  </div>
</template>

<script>
export default {
  data () {
    return {
      initQifeng: false, // 骑缝章位置初始化
      showQiFeng:false,
      // 当前用户选中拖拽的章的dom对象
      objCurrentCachet: null,
      cachetMove: false,
      currentIndex: null, // 当前拖动的item
      // 小地图 拖动相对位移
      deviationSmallMap: {
        left: 0,
        top: 0,
        width: 0,
        height: 0,
        clientWidth: 0,
        clientHeight: 0
      },
    };
  },
  props: {
    // 缩放比例结合sync
    scaleValue: { type: Number, default: 100 },
    // 自定义骑缝章列表
    qifengChapList:{type:Array,default:[]},
    imgBox:{ width: 0, height: 0 },
    // 总页数
    items: { type: Number, default: 0 },
  },
  watch: {
    showQiFeng(val){
      if(val && !this.initQifeng){
        const _this = this;
      _this.$nextTick(()=>{
        const list = JSON.parse(JSON.stringify(_this.qifengChapList));
        list.forEach((chap,i) =>{
          _this.qifengDefalut({pageX:0,pageY:chap.offsetY,...chap})
          // 执行完成之后不要再执行
          if(i === list.length-1) this.initQifeng = true
        });
      })
      }
    }
  },
  computed: {},
  filters: {
    eclipse (value) {
      if (!value) return "";
      let maxNum = 23;
      value = value + "";
      return value.length > maxNum ? value.substr(0, maxNum) + "..." : value;
    }
  },
  mounted () {},
  methods: {
    /** 横向滚动到底部 */
    scrollRight(){
      this.showQiFeng = !this.showQiFeng
      this.$nextTick(() => {
        this.$refs.qifengBox.scrollIntoView({inline:'end'})
      })
    },
    /**
     * js根据节点名称，查找某节点的特定父节点
     * @className 父节点中含有当前class的节点
     * */
    getParentNode (node, className) {
      if (!node) return "";
      if (node.nodeName == "BODY") return node;
      let tnode = node.parentNode;
      let cName = tnode.getAttribute("class");
      if (cName === className) return tnode;
      return this.getParentNode(tnode, className);
    },
    dropData (ev) {
      ev.preventDefault();
    },
    /********* 签章拖拽效果 start ************/
    // 签章停止事件
    handleCacheStop: function (el) {
      el.preventDefault();
      this.doCachetStop();
    },
    // 签章鼠标按下事件
    handleCacheMousedown: function (el, {currentIndex}) {
      el.preventDefault();
      this.doCachetStart();
      this.currentIndex = currentIndex; // 记录当前拖动的第几项
      this.objCurrentCachet = this.getParentNode(el.target,'qifeng-sign'); // 获取move dom
      if (!this.objCurrentCachet) return;
      document.addEventListener("mousemove", this.handleCacheMousemove, false);
      document.addEventListener("mouseup", this.handleCacheStop, false);
    },
    // 签章随着鼠标移动事件
    handleCacheMousemove: function (el) {
      el.preventDefault();
      if (!this.cachetMove && !this.objCurrentCachet) return;
      let {
        top: contBoxTop,
        left: contBoxLeft,
        width: contBoxW,
        height: contBoxH
      } = this.$el.querySelector('.qifeng-box').getBoundingClientRect();
      let { pageX: mouseX, pageY: mouseY } = el;
      let {
        width: caechetW,
        height: caechetH
      } = this.objCurrentCachet.getBoundingClientRect();
      let top = mouseY - contBoxTop - caechetH / 2;
      // let left = mouseX - contBoxLeft - caechetW / 2;
      // 处理边界情况
      let boundaryValue = this.scaleToVal(35); // 合同的最小边界值
      if (top < boundaryValue) {
        top = boundaryValue;
      } else if (top > contBoxH - caechetH - boundaryValue) {
        top = contBoxH - caechetH - boundaryValue;
      }
      top = this.scaleToShow(top);
      this.objCurrentCachet.style.top = `${top}px`;
      console.log('mouseY移动',mouseY);
    },

    // 签章停止移动
    doCachetStop: function () {
      this.cachetMove = false;
      document.removeEventListener(
        "mousemove",
        this.handleCacheMousemove,
        false
      );
      document.removeEventListener("mouseup", this.handleCacheStop, false);
      if (this.objCurrentCachet) {
        if (this.qifengChapList.length) {
          let cindex = this.currentIndex;
          let y = 0;
          if (this.objCurrentCachet) {
            y =
              this.objCurrentCachet.height ||
              this.objCurrentCachet.clientHeight ||
              this.objCurrentCachet.naturalHeight;
          }
          console.log('拖动的章',this.objCurrentCachet.getBoundingClientRect());
          let {
            top: contBoxTop,
            left: contBoxLeft,
            width: contBoxW,
            height: contBoxH
          } = this.$el.querySelector('.qifeng-box').getBoundingClientRect();
          const offY = parseFloat(
            (
              (parseInt(this.objCurrentCachet.style.top) + y/2) / contBoxH
            ).toFixed(4)
          )
          this.$emit('updateQifeng',{offY,y,cindex})
        }
        this.objCurrentCachet = null;
        this.currentIndex = null;
      }
    },

    // 签章移动开始
    doCachetStart: function () {
      this.cachetMove = true;
    },
    /********* 签章拖拽效果 end ************/
    // 骑缝章默认位置
    qifengDefalut: function ({pageX,pageY:mouseY,cindex}) {
      const qifeNode = document.querySelector(`#qifengSign${cindex+''}`)
      let {
        top: contBoxTop,
        left: contBoxLeft,
        width: contBoxW,
        height: contBoxH
      } = document.querySelector('.qifeng-box').getBoundingClientRect();
      let {
        width: caechetW,
        height: caechetH
      } = qifeNode.getBoundingClientRect(),
      y =
              qifeNode.height ||
              qifeNode.clientHeight ||
              qifeNode.naturalHeight;
      // 处理边界情况
      let boundaryValue = this.scaleToVal(35); // 合同的最小边界值
      let top = mouseY * parseInt(contBoxH) - (caechetH/2);
      // 加入缩放因子
      // top = this.scaleToShow(top);
      console.log('默认y',mouseY);
      // console.log('加入缩放因子后的值',left,top)
      qifeNode.style.top = `${top}px`;
    },
    // 更具cindx删除签章
    delChapter (cindx) {
      this.$emit("del-chapte", cindx);
    },
    // 页面缩放后的值重新计算为页面真正的值
    scaleToShow (val) {
      return parseFloat(val) / (this.scaleValue / 100);
    },
    // 页面缩放-真实值计算为缩放后的值
    scaleToVal (val) {
      return parseFloat(val) * (this.scaleValue / 100);
    },
  },
  name: "contract-view"
};
</script>

<style lang="less" scoped>
@goPageHeight: 0;
@sliderHeight: 60px;
.big-box {
  box-sizing: border-box;
  transform-origin: 0 0;

  .cont-box {
    /*position: absolute;*/
    position: relative;
    margin: 0 auto;
    box-sizing: border-box;
    top: 0;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-color: #ffffff;

    img {
      vertical-align: top;
    }
  }

  .cachet-box {
    position: absolute;
    display: inline-block;
    box-sizing: border-box;
    top: 300px;
    left: 500px;
    cursor: move;
  }

  .chapte-postion {
    box-sizing: border-box;
    width: 100px;
    height: 64px;
    text-align: center;
    line-height: 64px;
    background: rgba(0, 0, 0, 0.5);
    border: 2px dashed #fff;
    color: #fff;
    cursor: pointer;
  }

  .del-chapter {
    display: inline-block;
    font-size: 18px;
    position: absolute;
  }

  .del-chapter__create {
    left: -18px;
    top: calc(50% - 9px);
  }

  .del-chapter__sign {
    top: 0px;
    right: -18px;
    z-index: 50;
    color: #666666;
  }
}

.small-box {
  position: absolute;
  width: 140px;
  z-index: 20;
  opacity: 0.5;
  border: 1px solid #03af03;

  .float-box {
    position: absolute;
    box-sizing: border-box;
    top: 0;
    width: 30%;
    height: 30%;
    background: #ffffff;
    border: 1px dashed red;
    opacity: 0.5;
    cursor: move;
  }

  img {
    width: 100%;
    vertical-align: top;
    max-height: 195px;
  }
}

.contract-view {
  position: relative;
  vertical-align: top;
  /*width: 100%;*/
  height: 100%;
  overflow-y: auto;
  overflow-x: auto;
  width: 100%;
  box-sizing: border-box;
  padding-top: 5px;
  /deep/ .el-loading-mask {
    z-index: 10;
  }
}

.page-shwo {
  position: absolute;
  top: @goPageHeight;
  /*width: 100%;*/
  left: 0;
  right: 0;
  z-index: 10;
  padding: 16px 0;
}

.chapte-img {
  animation: chapteShow 1.3s ease-out;
}

// 新版样式
.qz-new {
  width: 100px;
  opacity: 1;
  /*position: relative;*/
  &.enterprise_qz_new {
    //! 这个值不要轻易改动，会影响到骑缝章自定义位置的计算
      height: 208px;
  }
  h1 {
    height: 25px;
    background: #ffa7a7;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 25px;
    color: rgba(255, 255, 255, 1);
    padding-left: 5px;
    box-sizing: border-box;
    border-radius: 6px 6px 0px 0px;
    text-align: left;
    transition: all ease 0.2s;
  }

  .con {
    transition: all ease 0.2s;
    opacity: 0.7;
    font-size: 12px;
    text-align: center;
    position: relative;
    height: 55px;
    border: 1px solid rgba(236, 28, 28, 1);
    border-style: none dashed dashed dashed;
    box-sizing: border-box;
    padding: 18px 5px;
    border-radius: 0 0 10px 10px;
    background: #ffffff;
    text-overflow: ellipsis;
    .text {
      text-overflow: ellipsis;
      display: -webkit-box;
      overflow: hidden;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    &.enterprise_con {
      //! 这个值不要轻易改动，会影响到骑缝章自定义位置的计算
      height: 208px;
    }
    &.padding_top {
      padding-top: 5px;
    }
  }

  img {
    position: absolute;
    width: 15px;
    height: 15px;
    left: 50%;
    bottom: -8px;
    margin-left: -8px;
  }

  .del-chapter {
    position: absolute;
    top: -9px;
    right: -10px;
    color: #a1a1a1;
    z-index: 54;
  }

  .time {
    position: absolute;
    left: 4px;
    bottom: 2px;
    z-index: 2;
    font-size: 10px;
    color: rgba(236, 28, 28, 1);
  }
}

.draging {
  /*opacity: 0.7;*/
  position: relative;
  z-index: 80;

  h1 {
    background: rgba(236, 28, 28, 1);
  }

  .con {
    opacity: 1;
  }
}

.d-new {
  position: relative;

  .del-chapter {
    color: #a1a1a1;
    top: -9px;
    right: -10px;
  }
}

.is-draging {
  &:after {
    position: absolute;
    top: -10px;
    bottom: -10px;
    right: -20px;
    left: -20px;
    /*padding: 10px 20px;*/
    content: " ";
    border: 1px dashed #ec1c1c;
    border-radius: 2px;
  }

  .del-chapter {
    top: -19px;
    right: -30px;
  }

  .move {
    position: absolute;
    width: 15px;
    height: 15px;
    left: -28px;
    top: 50%;
    margin-top: -8px;
  }
}

@keyframes chapteShow {
  from {
    transform: scale(1.3);
  }
  to {
    transform: scale(1);
  }
}
.qifeng-box{
  min-width: 208px;
  width: 9vw;
  height: 100%;
  position: absolute;
  top: 0;
  right: -173px;
  border: 1px dashed #ff95a8;
  display: flex;
  .qifeng-page{
    width: 3vw;
    height: 100%;
    background-color: #fff;
    box-shadow: inset 5px 0px 7px #ccc;
  }
}
.qifeng-drap{
  box-shadow: 0px 0px 10px 3px #ff95a8;
}
.vertical-text {
  position: absolute;
  top: 35%;
  left: 24%;
  font-size: 3vw;
  font-weight: 500;
  color: pink;
  letter-spacing: 6vh;
  writing-mode: vertical-rl; /* 文字从上到下，从右到左 */
  // transform: rotate(180deg); /* 可选，使文字从上到下，从左到右 */
}
.qifeng-switch{
  display: inline-block;
  position: absolute;
  top: 45vh;
  left: -1.3vw;
  border: 1px solid #f0f0f0;
  writing-mode: vertical-rl;
  letter-spacing: 1vh;
  background-color: #ec1c1c;
  color:#ffffff;
  padding-top: 1vh;
}
.close-qifeng{
  position: absolute;
  top: 5vh;
  right: -1px;
  padding: 7px;
  line-height: 1.3;
  // width: 4vw;
  // .text{
  //   writing-mode: vertical-lr;
  //   height: 13vh;
  //   padding-top: 1vh;
  // }
}
</style>



// WEBPACK FOOTER //
// components/contract-view/qifengSign.vue